var _rect, _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _g4, _path8, _path9, _g5, _path0, _path1, _g6, _path10, _path11, _g7, _path12, _g8, _g9, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9373_26677)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 98,
    width: 98,
    height: 98,
    rx: 49,
    transform: "rotate(-90 0 98)",
    fill: "url(#paint0_linear_9373_26677)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9287 44.4914C28.9287 44.4914 45.1852 43.3831 45.2959 60.7748C27.8168 60.6645 28.9287 44.4914 28.9287 44.4914Z",
    fill: "#71B261"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9373_26677",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 43,
    width: 20,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9241 43.0902H46.6006V61.871H27.9241V43.0902Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9373_26677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2454 61.7282L45.2894 61.7232C39.6517 61.6856 35.2668 60.0332 32.2555 56.8035C27.5411 51.751 27.9663 44.7301 27.9864 44.4343L28.0418 43.6193L28.8644 43.5617C28.8644 43.5617 29.0958 43.5441 29.5034 43.5441C32.2807 43.5441 46.1347 44.3766 46.2403 60.7754L46.2454 61.7282Z",
    fill: "url(#paint1_linear_9373_26677)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9373_26677",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 26,
    width: 14,
    height: 27
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4478 26H54.9721V52.0751H41.4478V26Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9373_26677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2892 51.7457L47.6176 51.0687C43.6553 47.0768 41.7308 42.8216 41.8969 38.421C42.156 31.5305 47.444 26.8667 47.6704 26.6736L48.2892 26.1345L48.9106 26.6736C49.137 26.8667 54.425 31.5305 54.6842 38.421C54.8502 42.8216 52.9257 47.0768 48.9635 51.0687L48.2892 51.7457Z",
    fill: "url(#paint2_linear_9373_26677)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1113 44.4914C68.1113 44.4914 51.8573 43.3831 51.7441 60.7748C69.2257 60.6645 68.1113 44.4914 68.1113 44.4914Z",
    fill: "#71B261"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9373_26677",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 43,
    width: 20,
    height: 19
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4641 43.0902H69.1407V61.871H50.4641V43.0902Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9373_26677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.7937 61.7282L50.8012 60.7754C50.9069 44.3766 64.7609 43.5441 67.5357 43.5441C67.9457 43.5441 68.1772 43.5617 68.1772 43.5617L68.9973 43.6193L69.0552 44.4343C69.0753 44.7301 69.5004 51.7485 64.786 56.8035C61.7772 60.0332 57.3899 61.6856 51.7497 61.7232L50.7937 61.7282Z",
    fill: "url(#paint3_linear_9373_26677)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9373_26677",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 53,
    width: 45,
    height: 52
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6313 53.7663H70.4246V104.001H26.6313V53.7663Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9373_26677)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_9373_26677",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 53,
    width: 45,
    height: 52
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3853 104.004V53.8099C56.2369 53.7999 56.091 53.7999 55.9426 53.7999H41.1301V104.004H56.3853ZM37.3339 104.004H41.1301V53.8099H41.0471C34.9088 53.8099 29.5202 58.8023 29.0774 64.8979L27.002 92.9288C26.5466 99.0119 31.1982 104.004 37.3339 104.004ZM59.6532 104.004C65.7915 104.004 70.4405 99.0119 69.9877 92.9162L67.9097 64.8879C67.467 58.9402 62.3224 54.0431 56.3753 53.8099V104.004H59.6532Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_9373_26677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.0192 104.005H27.0007V53.7704H70.0192V104.005Z",
    fill: "#FFDE59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6603 86.2019C51.242 85.541 47.1351 86.6079 43.9462 87.8775C42.9582 88.2708 43.3083 89.505 44.3686 89.4225C48.4 89.1087 53.0825 88.7738 54.5 88.7738C56.2954 88.7738 55.8075 87.4308 55.2066 86.5531C55.0794 86.3673 54.8814 86.2446 54.6603 86.2019Z",
    fill: "#353535"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_9373_26677",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 52,
    width: 20,
    height: 21
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26 52.4969H45.6074V72.04H26V52.4969Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_9373_26677)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_9373_26677",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 52,
    width: 20,
    height: 21
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8037 52.5013C30.3899 52.5013 26 56.8743 26 62.2729C26 67.6689 30.3899 72.0444 35.8037 72.0444C41.2175 72.0444 45.6074 67.6689 45.6074 62.2729C45.6074 56.8743 41.2175 52.5013 35.8037 52.5013Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_9373_26677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 52.5013H45.6074V72.0444H26V52.5013Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_9373_26677",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 55,
    width: 13,
    height: 13
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M28 55H40.2263V67.1888H28V55Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_9373_26677)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_9373_26677",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 55,
    width: 13,
    height: 13
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1151 55C30.739 55 28.002 57.7281 28.002 61.0956C28.002 64.4606 30.739 67.1887 34.1151 67.1887C37.4912 67.1887 40.2282 64.4606 40.2282 61.0956C40.2282 57.7281 37.4912 55 34.1151 55Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_9373_26677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.002 55H40.2282V67.1887H28.002V55Z",
    fill: "#3D1F1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.2985,
    cy: 58.2871,
    rx: 2.29849,
    ry: 2.28709,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_9373_26677",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 52,
    width: 21,
    height: 21
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3933 52.4969H71.0007V72.04H51.3933V52.4969Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_9373_26677)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_9373_26677",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 52,
    width: 21,
    height: 21
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1992 52.5014C55.7829 52.5014 51.3955 56.8744 51.3955 62.2729C51.3955 67.669 55.7829 72.0445 61.1992 72.0445C66.613 72.0445 71.0029 67.669 71.0029 62.2729C71.0029 56.8744 66.613 52.5014 61.1992 52.5014Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_9373_26677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.3955 52.5014H71.0029V72.0445H51.3955V52.5014Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_9373_26677",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 55,
    width: 13,
    height: 13
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1157 55C55.7371 55 53 57.7281 53 61.0956C53 64.4606 55.7371 67.1888 59.1157 67.1888C62.4917 67.1888 65.2288 64.4606 65.2288 61.0956C65.2288 57.7281 62.4917 55 59.1157 55Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_9373_26677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 55H65.2288V67.1888H53V55Z",
    fill: "#3D1F1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2985,
    cy: 58.2871,
    rx: 2.29849,
    ry: 2.28709,
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9373_26677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.3235 45.1182L71.1286 49.3001C70.9812 49.8162 71.6397 50.1704 71.989 49.7629L76.2941 44.7402C76.4198 44.5935 76.6175 44.5325 76.8046 44.5809C82.2858 45.9987 89.8975 45.8858 92.5 37.5C97 23 87.5 21.5 83 19.5C78.7875 17.6278 61.5001 12 58.5001 28C56.1878 40.3325 66.0669 44.0629 71.8598 44.468C72.1851 44.4907 72.413 44.8047 72.3235 45.1182Z",
    fill: "white"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8435 34.3244L75.0083 33.4763C75.4717 31.0909 78.5324 31.0987 78.9237 29.0843C79.1125 28.1125 78.6239 27.2291 77.4578 27.0026C76.3092 26.7795 75.6777 27.4819 75.3273 27.964L73.9416 26.9796C74.4627 26.0907 75.7091 24.8659 77.8825 25.2881C80.1265 25.7241 81.3008 27.4191 80.9233 29.3628C80.3844 32.1369 77.2177 32.1085 76.8607 33.9461L76.7165 34.6883L74.8435 34.3244ZM74.0935 36.5808C74.2273 35.8917 74.9026 35.4361 75.5917 35.57C76.2808 35.7038 76.7364 36.3791 76.6026 37.0682C76.4721 37.7397 75.7968 38.1953 75.1077 38.0614C74.4186 37.9275 73.963 37.2522 74.0935 36.5808Z",
    fill: "#353535"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9373_26677",
    x: 56.1558,
    y: 16.0028,
    width: 39.5247,
    height: 36.9374,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9373_26677"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9373_26677",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9373_26677",
    x1: 0.00000171925,
    y1: 184.555,
    x2: 98,
    y2: 98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00221239,
    stopColor: "#FF4E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9373_26677",
    x1: 37.1068,
    y1: 43.5441,
    x2: 37.1068,
    y2: 61.7282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9373_26677",
    x1: 48.2905,
    y1: 26.1345,
    x2: 48.2905,
    y2: 51.7457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9373_26677",
    x1: 59.9335,
    y1: 43.5441,
    x2: 59.9335,
    y2: 61.7282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9373_26677"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 98,
    width: 98,
    height: 98,
    rx: 49,
    transform: "rotate(-90 0 98)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordLogo);
export default __webpack_public_path__ + "static/media/passwordLogo.535c9666771bf62d2aa7b634af8863df.svg";
export { ForwardRef as ReactComponent };